import request from '@/utils/request'
import qs from 'qs'


// 查询列表 通过编号
export function getOrderListReq(query) {
  return request({
    url: '/api/order/getOrderList',
    method: 'GET',
    params: query , //params修改为data
  })
}
//取消订单
export function closeOrderReq(query) {
  return request({
    url: '/api/order/closeOrder',
    method: 'GET',
    params: query , //params修改为data
  })
}
//再次购买
export function buyAgainReq(query) {
  return request({
    url: '/api/order/buyAgain',
    method: 'GET',
    params: query , //params修改为data
  })
}
//重新支付 返回二维码
export function payOrderByWxPCReq(query) {
  return request({
    url: '/api/order/payOrderByPC',
    method: 'POST',
    data: query , //params修改为data
  })
}

//延迟收货
export function extendedReceiptReq(query) {
  return request({
    url: '/api/order/extendedReceipt',
    method: 'GET',
    params: query , //params修改为data
  })
}

//删除订单
export function deleteOrderReq(query) {
  return request({
    url: '/api/order/deleteOrder',
    method: 'GET',
    params: query , //params修改为data
  })
}

//确认收货
export function confirmReceiptReq(query) {
  return request({
    url: '/api/order/confirmReceipt',
    method: 'GET',
    params: query , //params修改为data
  })
}
//获取订单详情
export function getOrderDetailReq(query) {
  return request({
    url: '/api/order/getOrderDetail',
    method: 'GET',
    params: query , //params修改为data
  })
}

//获取物流信息
export function queryTrackReq(query) {
  return request({
    url: '/api/express/queryTrack',
    method: 'GET',
    params: query , //params修改为data
  })
}

//获取
export function getMonthListReq(query) {
  return request({
    url: '/api/dealer/getMonthList',
    method: 'GET',
    params: query , //params修改为data
  })
}
